// auth
export const LOGIN_URL = '/authenticate';
export const STATE_URL = '/hub/state';

//dashboard
export const getIssuedLicencesCountBySoftwareProduct_URL = '/hub/dashboard/getIssuedLicencesCountBySoftwareProduct';
export const getIssuedLicencesCountByYear_URL = '/hub/dashboard/getIssuedLicencesCountByYear';
export const getRegisteredCompanyCount_URL = '/hub/dashboard/getRegisteredCompanyCount';
export const getActiveLicenceCount_URL = '/hub/dashboard/getActiveLicenceCount';
export const getIssuedLicencesCount_URL = '/hub/dashboard/getIssuedLicencesCount/{date}';
export const getLicencesThatExpireUntilDateCount_URL = '/hub/dashboard/getLicencesThatExpireUntilDateCount/{date}';

export const companyHasSoftwareProduct_URL = '/hub/companyHasSoftwareProduct';
export const expiryLicenceAction_URL = '/hub/expiryLicenceAction';
export const company_URL = '/hub/company';
export const softwareProductElement_URL = '/hub/softwareProductElement';
export const softwareProduct_URL = '/hub/softwareProduct';

export const companyById_URL = '/hub/company/{id}';
export const companyHasSoftwareProduct_byCompanyId_URL = '/hub/companyHasSoftwareProduct/getAllByCompanyId/{id}';
export const companyHasSoftwareProductDelete_URL = '/hub/companyHasSoftwareProduct/{id}';

//company
export const COMPANIES_URL = '/hub/company/getAllCompaniesWithSoftwareProducts';
export const COMPANIES_POST_URL = '/hub/company/insertCompanyWithProducts';
export const COMPANIES_POST_URL_SIMPLE = '/hub/company';
export const COMPANIES_PUT_URL = '/hub/company/{id}';
export const COMPANY_DELETE_URL = '/hub/company/{id}';

// licence
export const LICENCES_URL = '/hub/licence/getAllWithCompanyAndProduct';
export const LICENCE_POST_URL = '/hub/licence/generateLicence/{companyHasSoftwareProductId}';
export const COMPANY_ADD_SW_PRODUCTS_URL = '/hub/companyHasSoftwareProduct/insertSingle';
export const COMPANIES_URL_FOR_LICENCE = '/hub/company';
export const SOFTWARE_PRODUCT_URL = '/hub/softwareProduct';

export const LICENCE_DOWNLOAD_URL = '/hub/licence/downloadLicence/{id}';
export const LICENCE_DOWNLOAD_PUBLIC_KEY = '/hub/licence/downloadPublicKey/{id}';
export const LICENCE_SEND_LICENCE_URL = '/hub/licence/sendLicence/{id}';
export const LICENCE_SEND_PASSWORD_URL = '/hub/licence/sendPassword/{id}';
export const LICENCE_SEND_OFFLINE_TOKEN_VIA_SMS_URL = '/hub/licence/sendOfflineValidationTokenSms/{id}';
export const LICENCE_SEND_OFFLINE_TOKEN_VIA_EMAIL_URL = '/hub/licence/sendOfflineValidationTokenMail/{id}';
export const LICENCE_REVOKE_URL = '/hub/licence/revokeLicence/{id}';
export const LICENCE_DELETE_URL = '/hub/licence/deleteLicence/{id}';
